export const isEmptyContentfulEntry = (content) => {
  return (
    (content?.raw?.includes("#") && !content?.raw?.includes("hyperlink")) ||
    !content ||
    content === "#" ||
    (typeof content === "object" && content !== null && !Array.isArray(content) && Object.keys(content).length === 0) ||
    (content?.content?.[0]?.content?.[0]?.value?.trim() === "#")
  );
};